import { Component } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/socialFeed/FeedPost/AttachmentsBlock.styl'
import { Attachments } from 'interfaces/feed'
import { ImageURLs, MediaLink } from 'interfaces/media'
import { FetchedLink } from 'components/features/socialFeed/FeedPost/FetchedLink'
import LightboxImage from 'components/features/pfm/LightboxImage/LightboxImage'

type AttachmentMode = 'post' | 'comment'

type AttachmentsBlockProps =
  & Attachments
  & {
    mode: AttachmentMode
  }

class AttachmentsBlock extends Component<AttachmentsBlockProps> {
  render () {
    const { images, links } = this.props
    return (
      <>
        { images.length !== 0 && this.renderImages(images) }
        { images.length === 0 && links[0] && this.renderFetchedLink(links[0]) }
      </>
    )
  }

  private renderImages (images: ImageURLs[]) {
    return images.map((image) => (
      <div
        key={ image.id }
        className={ cn(styles.image, { [styles.commentMode]: this.props.mode === 'comment' }) }
      >
        <LightboxImage image={ image } />
      </div>
    ))
  }

  private renderFetchedLink (link: MediaLink) {
    return (
      <FetchedLink
        className={ cn(styles.fetchedLink, { [styles.commentMode]: this.props.mode === 'comment' }) }
        { ...link }
      />
    )
  }

}

export default AttachmentsBlock
